import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef, SimpleChanges, OnChanges } from '@angular/core';
import { CompanySvc, NotificationsSvc } from '../../services';
import {  GtmManagerSvc } from 'src/app/dashboard/services/gtm-manager.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-qrag-assistance',
  templateUrl: './qrag-assistance.tpl.html',
  styleUrls: ['./qrag-assistance.less']
})
export class QragAssistanceComponent implements OnInit, OnChanges {

  @Input() public active !: boolean;
  public isCollapsed: boolean = true;
  public pending : boolean = false;
  public activeNotification : boolean = false;
  private autoCloseTimeout?: ReturnType<typeof setTimeout>;
  private autoOpenTimeout?: ReturnType<typeof setTimeout>;

  constructor(private notifSvc : NotificationsSvc,
     private tagManager : GtmManagerSvc,
     private companySvc : CompanySvc) {}

  public ngOnInit(): void {
    this.activeNotification = this.notifSvc.isNotificationActive;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    const firstChange =  changes['active']?.firstChange;
    const activeChange =  changes['active']?.currentValue;
    if (!firstChange && activeChange && this.isCollapsed) {
      this.setAutoOpen();
    }
  }

  public close(): void {
    this.isCollapsed = true;
    clearTimeout(this.autoCloseTimeout);
  }
  public redirect(): void {
    this.sendGtmEvent('clic_col_popin_contact');
    window.open(environment.URL_ASISSTANCE_QRAG, '_blank');
  }

  public open(): void {
    this.isCollapsed = false;
    this.setAutoClose();
    this.sendGtmEvent('cons_col_popin_contact');
  }

  private setAutoClose(): void {
    clearTimeout(this.autoCloseTimeout);
    this.autoCloseTimeout = setTimeout(() => {
      this.close();
    }, 30000);
  }
   private setAutoOpen(): void {
    this.pending = true;
    clearTimeout(this.autoOpenTimeout);
    this.autoOpenTimeout = setTimeout(() => {
      this.pending = false;
      this.open();
    }, 3000);
  }
  private sendGtmEvent(eventName : string){
    return this.tagManager.trackEvent(eventName, {
        gln : this.companySvc.company.gln
      });
  }

}
